export default function (context) {
	// If the user is not authenticated
	if (context.$cookie.get('affiliateToken')) {
		return context.redirect('/agent/affiliate');
	}
}